import { EditIcon, EyeIcon, TrashIcon } from "assets";
import {
  CustomTooltip,
  MediumScreenModel,
  SmallScreenModel,
  SwitchButton,
} from "components";
import React, { useState } from "react";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import HandleUpdateFeaturedAds from "./HandleUpdateFeaturedAds";
import HandleDeleteFeaturedAds from "./HandleDeleteFeaturedAds";
import { FeaturedAdsStatusEnum } from "props/enum";
import HandleChangeStatus from "./HandleChangeStatus";
import { PreviewImage } from "./components/PreviewFeaturedAds";
import { FeaturedAdsProps } from "../state/actionType";
import { SuperAdminStatusEnum } from '../../../props/enum';

const ActionButton: React.FC<{ items: FeaturedAdsProps }> = ({ items }) => {
  const [isEditModel, setEditModel] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [isDeleteModel, setDeleteModel] = useState(false);
  const [isStatusModel, setStatusModel] = useState(false);
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_FEATURED_ADS));
  if (isPermitted)
    return (
      <>
        <div className="flex flex-row gap-2 justify-center">
          <CustomTooltip title="Preview" placement="bottom">
            <button
              className="hover:text-primary-900"
              onClick={() => setIsPreview(true)}
            >
              <EyeIcon />
            </button>
          </CustomTooltip>
          <CustomTooltip title="Edit" placement="bottom">
            <button
              className="hover:text-primary-500"
              onClick={() => setEditModel(true)}
            >
              <EditIcon />
            </button>
          </CustomTooltip>
          <CustomTooltip title="Delete" placement="bottom">
            <button
              className="hover:text-red-500"
              onClick={() => setDeleteModel(true)}
            >
              <TrashIcon className="" />
            </button>
          </CustomTooltip>
          <CustomTooltip
            title={
              items.status === FeaturedAdsStatusEnum.Published
                ? FeaturedAdsStatusEnum.Draft
                : FeaturedAdsStatusEnum.Published
            }
            placement="bottom"
          >
            <button onClick={() => setStatusModel(true)}>
              <SwitchButton
                id={"status"}
                name={"status"}
                value={items.status === FeaturedAdsStatusEnum.Published}
                onChange={() => setStatusModel(true)}
              />
            </button>
          </CustomTooltip>
        </div>
        <MediumScreenModel setShowModal={setEditModel} showModal={isEditModel}>
          <HandleUpdateFeaturedAds
            featuredaAdsData={items}
            onClose={() => setEditModel(!isEditModel)}
          />
        </MediumScreenModel>
        <SmallScreenModel
          setShowModal={setDeleteModel}
          showModal={isDeleteModel}
        >
          <HandleDeleteFeaturedAds
            featuredAdsData={items}
            onClose={() => setDeleteModel(!isDeleteModel)}
          />
        </SmallScreenModel>
        <SmallScreenModel
          setShowModal={setStatusModel}
          showModal={isStatusModel}
        >
          <HandleChangeStatus
            onClose={() => setStatusModel(!isStatusModel)}
            featuredaAdsData={items}
          />
        </SmallScreenModel>
        <SmallScreenModel setShowModal={setIsPreview} showModal={isPreview}>
          <PreviewImage featuredData={items} />
        </SmallScreenModel>
      </>
    );
  return <></>;
};

export default ActionButton;
